import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    const sections = [
        t("privacyPolicy.introduction", { returnObjects: true }),
        t("privacyPolicy.informationWeCollect", { returnObjects: true }),
        t("privacyPolicy.howWeUse", { returnObjects: true }),
        t("privacyPolicy.dataProtection", { returnObjects: true }),
        t("privacyPolicy.thirdParty", { returnObjects: true }),
        t("privacyPolicy.yourRights", { returnObjects: true }),
        t("privacyPolicy.updates", { returnObjects: true }),
    ];

    return (
        <div className="max-w-3xl p-6 mx-auto space-y-4">
            {sections.map((section, idx) => (
                <div key={idx} className="p-4 overflow-hidden duration-300 border lg:p-6 bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
                >
                    <h2 className="mb-2 text-lg font-semibold">{section.heading}</h2>
                    {section.points ? (
                        <ul className="space-y-1 text-sm list-disc list-inside dark:text-text-muted-dark text-text-muted-light">
                            {section.points.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>
                    ) : (
                            <p className="text-sm dark:text-text-muted-dark text-text-muted-light">{section.text}</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PrivacyPolicy;
